var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1H7V2H6V3H5V2H3V1ZM2 3V2H3V3H2ZM2 8H1V3H2V8ZM3 9H2V8H3V9ZM4 10H3V9H4V10ZM9 10V11H4V10H9ZM10 9V10H9V9H10ZM9 7H10V9H11V5H10V6H9V7ZM6 7V8H9V7H6ZM5 6H6V7H5V6ZM5 6V3H4V6H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonS);
export default __webpack_public_path__ + "static/media/moon-s.7ea37fe2f74919b71d93a50bba47f9dc.svg";
export { ForwardRef as ReactComponent };